import { render, staticRenderFns } from "./ConfigurationLang.vue?vue&type=template&id=433a46c4&scoped=true"
import script from "./ConfigurationLang.vue?vue&type=script&lang=js"
export * from "./ConfigurationLang.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationLang.vue?vue&type=style&index=0&id=433a46c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a46c4",
  null
  
)

export default component.exports